import _ from 'lodash';
import { getField, updateField } from 'vuex-map-fields';
const state = {
    asesor: 'todos',
    estado: 'todos',
    placa: '',
    fecha_range: [],
    recaudo_asesor: []
};
const mutations = {
    updateField
};

const getters = {
    getField
};

export default {
    namespaced: true,
    state,
    mutations,
    getters
}
